// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"5efe1347","500":"70813824","641":"c873e7d8","682":"e5a68311","777":"c0e58542","778":"baea692c"}[chunkId] + ".chunk.css";
};